import { Field, reduxForm, SubmissionError } from "redux-form";
import useCreate from "hooks/useCreate";
import { Button, Checkbox, Input } from "expano-components";
import { Modal } from "components";

const validate = (values) => {
  let errors = {};
  if (!values.name) {
    errors.name = "Pole wymagane";
  }

  return errors;
};

const AddKeywordModal = ({
  product_group_id,
  refetch,
  country_code,
  valid,
  pristine,
  handleClose,
  handleSubmit,
}) => {
  const { is_creating, create } = useCreate({
    path: "product_group_country_keywords",
    onSuccess: () => [refetch(), handleClose()],
    onError: (err) => {
      throw new SubmissionError(err);
    },
  });

  const onSubmit = (values) =>
    create({ country_code, product_group_id, ...values });

  return (
    <Modal
      header={{ title: "Dodaj slowo kluczowe" }}
      handleClose={handleClose}
      footer={
        <>
          <Button type="cancel" onClick={handleClose} />
          <Button
            type="add-green"
            disabled={!valid || pristine || is_creating}
            text={is_creating ? "Proszę czekać..." : "Dodaj"}
            onClick={handleSubmit(onSubmit)}
          />
        </>
      }
    >
      <form onSubmit={handleSubmit(onSubmit)}>
        <input type="submit" style={{ display: "none" }} />
        <Field label="Nazwa" name="name" component={Input} />
        <Field type="number" label="Wolumen" name="volumen" component={Input} />
        <Field label="Czy tytułowe?" name="is_title" component={Checkbox} />
        <Field label="Czy użyte?" name="is_used" component={Checkbox} />
      </form>
    </Modal>
  );
};

export default reduxForm({
  form: "create-product-group-country-keyword",
  validate,
  enableReinitialize: true,
})(AddKeywordModal);
